import { render, staticRenderFns } from "./UploadImg.vue?vue&type=template&id=09868457&scoped=true&"
import script from "./UploadImg.vue?vue&type=script&lang=js&"
export * from "./UploadImg.vue?vue&type=script&lang=js&"
import style0 from "./UploadImg.vue?vue&type=style&index=0&id=09868457&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09868457",
  null
  
)

export default component.exports